<div fxLayout="column" fxFlexFill style="overflow: hidden">
   <div class="sam-form-flex-row">
      <fa-icon [fixedWidth]="true" class="folder-icon sam-center sam-margin-right" [icon]="skillTreeIcon"></fa-icon>
      <div fxFlex="1 1 auto" class="sam-margin-left sam-hide-overflow">
         <div class="skill">
            <samweb-skill-short-info
               [skills]="messageInfo?.skill?.skills"
               [skillConfiguration]="messageInfo?.skill?.skillConfiguration"
            ></samweb-skill-short-info>
         </div>
         <div class="sam-form-flex-row">
            <!-- need to add width so the overflow works correctly -->
            <div style="flex: auto; width: 10%">
               <samweb-text-with-overflow-tooltip [value]="email.subject" class="mail-subject">
               </samweb-text-with-overflow-tooltip>
            </div>
            <samweb-email-category [isInbox]="isInbox" [messageInfo]="messageInfo"></samweb-email-category>

            <span class="sam-margin-left action-bar">
               <span
                  [hidden]="actionId === 'REPLY_ALL' && receivers.length < 2"
                  *ngFor="let actionId of standardActionIds; let i = index"
               >
                  <samweb-email-reader-action-button
                     [messageId]="messageId"
                     [messageInfo]="messageInfo"
                     [actionId]="actionId"
                     [iconOnly]="true"
                     [mainActionIds]="standardActionIds"
                  ></samweb-email-reader-action-button>
               </span>
               <ng-container *ngIf="actionIds.length >= actionDisplayLength">
                  <span kendoButton look="flat" (click)="openDialog()" #actionExpandButton>
                     <fa-icon size="lg" class="reader-icon" [icon]="ellipsisIcon"></fa-icon>
                  </span>
                  <kendo-popup
                     *ngIf="displayAllActions"
                     class="popup"
                     [anchor]="actionExpandButton"
                     [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
                     [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
                     (samwebOutsideClick)="closeDialog()"
                  >
                     <div
                        class="popup-item"
                        fxFill
                        [hidden]="actionId === 'REPLY_ALL' && receivers.length < 2"
                        *ngFor="let actionId of actionIds; let i = index"
                     >
                        <samweb-email-reader-action-button
                           fxFill
                           [messageId]="messageId"
                           [messageInfo]="messageInfo"
                           [actionId]="actionId"
                           [iconOnly]="false"
                           [mainActionIds]="standardActionIds"
                        ></samweb-email-reader-action-button>
                     </div>
                  </kendo-popup>
               </ng-container>
            </span>
         </div>
      </div>
   </div>

   <div class="sam-form-control sam-form-control-full-width mail-details">
      <div class="sam-base-font-size sam-form-flex-row no-bottom-margin">
         <label class="sam-margin-right">
            {{ 'samwin.email_dialog.from' | translate }}
         </label>
         <samweb-text-with-overflow-tooltip [value]="email.from" fxFlex="1 1 auto" class="sam-hide-overflow">
         </samweb-text-with-overflow-tooltip>
         <ng-container *ngIf="messageInfo?.timestamp !== null">
            <span class="mail-details mail-details-top-margin align-right mail-date">
               {{ messageInfo.timestamp | toMoment$ | async | amDateFormat: 'LLL' }}
            </span>
         </ng-container>
      </div>

      <div class="sam-form-flex-row">
         <div fxFlex="1 1 auto" class="sam-margin-right-medium sam-hide-overflow">
            <div>
               <label class="sam-margin-right">
                  {{ 'samwin.email_dialog.to' | translate }}
               </label>
               <samweb-text-with-overflow-tooltip [value]="receiver" fxFlex="1 1 auto" class="sam-hide-overflow">
               </samweb-text-with-overflow-tooltip>
            </div>
            <div *ngIf="email.cc.length > 0">
               <label class="sam-margin-right">
                  {{ 'samwin.email_dialog.cc' | translate }}
               </label>
               <samweb-text-with-overflow-tooltip [value]="email.cc" fxFlex="1 1 auto" class="sam-hide-overflow">
               </samweb-text-with-overflow-tooltip>
            </div>
         </div>
      </div>
   </div>

   <div class="sam-form-control sam-form-control-full-width">
      <samweb-attachment-bar [attachments]="attachments" [messageId]="messageInfo.messageId"></samweb-attachment-bar>
   </div>

   <div class="content-window">
      <span samwebExternalLink [innerHtml]="email.body | safeHtml" class="sam-padding mail-content"> </span>
   </div>
</div>
